/* eslint-disable */
// @ts-nocheck
import DefaultLoggerAPI from './DefaultLoggerAPI';
import { LoggerAPI } from './LoggerAPI';
import { LoggerRegistry } from './LoggerRegistry';

class LoggerController {
	debugEnabled = false;
	infoEnabled = true;

	isDebugEnabled() {
		return this.debugEnabled;
	}

	isInfoEnabled() {
		return this.infoEnabled;
	}
}

/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */
class LoggerAdaptor implements LoggerRegistry {
	loggerController: LoggerController;
	loggerAPI = DefaultLoggerAPI;

	constructor() {
		this.loggerController = new LoggerController();
		(window as any)._loggerController = this.loggerController;
	}

	/**
	 * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
	 */
	registerLoggerAPI(loggerAPI: LoggerAPI): void {
		this.loggerAPI = loggerAPI;
	}

	/**
	 * Implementation of LoggerAPI#debug() for use by connect-module-core code.
	 */
	debug(message?: string, ...optionalParams: any[]): void {
		try {
			if (this.loggerController.isDebugEnabled()) {
				this.loggerAPI.debug.apply(this.loggerAPI, arguments);
			}
		} catch (exception) {
			// Ignore
		}
	}

	/**
	 * Implementation of LoggerAPI#info() for use by connect-module-core code.
	 */
	info(message?: string, ...optionalParams: any[]): void {
		try {
			if (this.loggerController.isInfoEnabled()) {
				this.loggerAPI.info.apply(this.loggerAPI, arguments);
			}
		} catch (exception) {
			// Ignore
		}
	}

	/**
	 * Implementation of LoggerAPI#warn() for use by connect-module-core code.
	 */
	warn(message?: string, ...optionalParams: any[]): void {
		try {
			this.loggerAPI.warn.apply(this.loggerAPI, arguments);
		} catch (exception) {
			const logger = console.warn || console.log;
			if (logger) {
				logger.apply(logger, arguments);
			}
		}
	}

	/**
	 * Implementation of LoggerAPI#error() for use by connect-module-core code.
	 */
	error(message?: string, ...optionalParams: any[]): void {
		try {
			this.loggerAPI.error.apply(this.loggerAPI, arguments);
		} catch (exception) {
			const logger = console.error || console.log;
			if (logger) {
				logger.apply(logger, arguments);
			}
		}
	}
}

export const logger = new LoggerAdaptor() as LoggerRegistry;
